import React, { useState } from "react";
import axios from "axios"; // Import axios for making HTTP requests
import "./checkResult.css";
import IsLoading from "../../../isLoading";
let result;
const CheckResult = ({ info }) => {
  const [loading, setLoading] = useState(false);
  const [session, setSession] = useState("");
  const [semester, setSemester] = useState("");
  const studentId =
    info?.admission_number || info?.academicInfo?.admission_number;

  const sessions = [
    "2025/2026",
    "2024/2025",
    "2023/2024",
    "2022/2023",
    "2021/2022",
    "2020/2021",
    "2019/2020",
    "2018/2019",
    "2017/2018",
    "2016/2017",
    "2015/2016",
    "2014/2015",
    "2013/2014",
  ];

  const semesters = ["All semester", "First Semester", "Second semester"];

  const handleSubmit = async () => {
    if (!session || !semester) {
      alert("Please select both session and semester.");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/results_checking`,
        {
          params: { session, semester, studentId },
        },
      );
      result = response?.data?.results; // Assuming the backend returns the filtered results
      console.log("Results: " + result);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching the result", error);
      alert("An error occurred while fetching the result.");
      setLoading(false);
    }
  };
  const apiGetAllSemester = async () => {
    if (!session || !semester) {
      alert("Please select both session and semester.");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/results_checking/all_semester`,
        {
          params: { session, semester, studentId },
        },
      );
      result = response?.data?.results; // Assuming the backend returns the filtered results

      setLoading(false);
    } catch (error) {
      console.error("Error fetching the result", error);
      alert("An error occurred while fetching the result.");
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? <IsLoading /> : null}
      {!result ? (
        <div className="check-result-container fx-cl space4">
          <h3 className="check-result-title">Check Result</h3>
          <div className="fx-ac space3">
            <div className="fx-cl">
              <label className="form-label" htmlFor="session">
                Select Session:
              </label>
              <select
                id="session"
                className="dropdown"
                value={session}
                onChange={(e) => setSession(e.target.value)}
              >
                <option value="">- Select -</option>
                {sessions?.map((sess, index) => (
                  <option key={index} value={sess}>
                    {sess}
                  </option>
                ))}
              </select>
            </div>

            <div className="fx-cl">
              <label className="form-label" htmlFor="semester">
                Select Semester:
              </label>
              <select
                id="semester"
                className="dropdown"
                value={semester}
                onChange={(e) => setSemester(e.target.value)}
              >
                <option value="">- Select -</option>
                {semesters?.map((sem, index) => (
                  <option key={index} value={sem}>
                    {sem}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {semester !== "All semester" ? (
            <button className="view-result-button" onClick={handleSubmit}>
              View Result
            </button>
          ) : (
            <button
              className="view-result-button"
              onClick={() => apiGetAllSemester()}
            >
              View Result
            </button>
          )}
        </div>
      ) : (
        <div className="course-registration">
          <table className="fx-cl spacem">
            <thead className="fx-cl spacem">
              <tr>
                <th>S/N</th>
                <th>Course Code</th>
                <th>Course Title</th>
                <th>Course Unit</th>
                <th>Course Semester</th>
              </tr>
            </thead>
            <tbody className="fx-cl">
              {result?.map((response, index) => {
                return (
                  <tr key={response.courseCode}>
                    <td>
                      <span>{index + 1}</span>
                    </td>
                    <td className=" fx-ac space2">
                      <span>{response.courseCode}</span>
                    </td>
                    <td>{response.courseTitle}</td>
                    <td>{response.creditUnit}</td>
                    <td>{response.semester}</td>
                  </tr>
                );
              })}
            </tbody>
            <div className="fx-jb">
              <span>&nbsp;</span>
              <button>Print</button>
            </div>
          </table>
        </div>
      )}
    </>
  );
};

export default CheckResult;
